var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMoreVertical = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 8.66663C8.36835 8.66663 8.66683 8.36815 8.66683 7.99996C8.66683 7.63177 8.36835 7.33329 8.00016 7.33329C7.63197 7.33329 7.3335 7.63177 7.3335 7.99996C7.3335 8.36815 7.63197 8.66663 8.00016 8.66663Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 3.99996C8.36835 3.99996 8.66683 3.70148 8.66683 3.33329C8.66683 2.9651 8.36835 2.66663 8.00016 2.66663C7.63197 2.66663 7.3335 2.9651 7.3335 3.33329C7.3335 3.70148 7.63197 3.99996 8.00016 3.99996Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 13.3333C8.36835 13.3333 8.66683 13.0348 8.66683 12.6666C8.66683 12.2984 8.36835 12 8.00016 12C7.63197 12 7.3335 12.2984 7.3335 12.6666C7.3335 13.0348 7.63197 13.3333 8.00016 13.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 8.66663C8.36835 8.66663 8.66683 8.36815 8.66683 7.99996C8.66683 7.63177 8.36835 7.33329 8.00016 7.33329C7.63197 7.33329 7.3335 7.63177 7.3335 7.99996C7.3335 8.36815 7.63197 8.66663 8.00016 8.66663Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 3.99996C8.36835 3.99996 8.66683 3.70148 8.66683 3.33329C8.66683 2.9651 8.36835 2.66663 8.00016 2.66663C7.63197 2.66663 7.3335 2.9651 7.3335 3.33329C7.3335 3.70148 7.63197 3.99996 8.00016 3.99996Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 13.3333C8.36835 13.3333 8.66683 13.0348 8.66683 12.6666C8.66683 12.2984 8.36835 12 8.00016 12C7.63197 12 7.3335 12.2984 7.3335 12.6666C7.3335 13.0348 7.63197 13.3333 8.00016 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more-vertical.6187334f.svg";
export { ForwardRef as ReactComponent };